module.exports = __webpack_public_path__ + "static/img/no8.c072cd9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/home/bannerbottom/no8.png
// module id = L0cA
// module chunks = 31